import { type Href, router } from "expo-router";
import { useEffect, useState } from "react";
import { Nothing } from "~/components/permission/Nothing";
import { useDismiss } from "~/providers/DismissProvider";

export type DismissProps = {
    to?: Href;
    after?: number;
};

export const Dismiss = ({ to, after = 10 }: DismissProps) => {
    const { handleDismiss } = useDismiss();
    const [dismiss_to] = useState(to);
    const [dismiss_after] = useState(after);

    // biome-ignore lint/correctness/useExhaustiveDependencies(handleDismiss): non-reactive
    useEffect(() => {
        const dismisser = dismiss_to ? () => router.dismissTo(dismiss_to) : handleDismiss;

        setTimeout(dismisser, dismiss_after);
    }, [dismiss_to, dismiss_after]);

    return <Nothing />;
};
